var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('div',{style:({
        width: this.source.length * 200 + 250 + 'px',
        height: '500px',
        margin: 0
      }),attrs:{"id":"report"}})]),_c('div',{staticClass:"sections section"})])}
var staticRenderFns = []

export { render, staticRenderFns }